import { render, staticRenderFns } from "./MarketShare.vue?vue&type=template&id=250f9552&scoped=true"
import script from "./MarketShare.vue?vue&type=script&lang=js"
export * from "./MarketShare.vue?vue&type=script&lang=js"
import style0 from "./MarketShare.vue?vue&type=style&index=0&id=250f9552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f9552",
  null
  
)

export default component.exports